module.exports = __webpack_public_path__ + "assets/img/img-map-miyazaki-sp.fa5f84af.svg";